import { IRoutingProjectPlanModel } from 'features/RoutingProjects/types'
import { LockRoutingProjectPlanOptimizationRoutePlanOptimizationInput } from 'gql/generated/graphql'

export const freezeAllRoutes = (planModel: IRoutingProjectPlanModel): IRoutingProjectPlanModel => {
  return {
    ...planModel,
    optimizations: planModel.optimizations.map((optimization) => {
      return {
        ...optimization,
        routes: optimization.routes.map((r) => {
          return {
            ...r,
            isLocked: true
          }
        })
      }
    })
  }
}

export const getOptimizationsInputToLockAllRoutes = (
  optimizations: IRoutingProjectPlanModel['optimizations']
): LockRoutingProjectPlanOptimizationRoutePlanOptimizationInput[] => {
  return optimizations.flatMap((optimization) =>
    optimization.routes.map((route) => ({
      id: optimization.id,
      route: {
        id: route.id
      }
    }))
  )
}
